import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _approveDraftPostRequest = {};
var _approveDraftPostResponse = { draftPost: '_draftPost' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _blogMedia = { wixMedia: '_wixMedia' };
var _bulkCreateDraftPostsRequest = { draftPosts: '_draftPost' };
var _bulkCreateDraftPostsResponse = { results: '_bulkDraftPostResult' };
var _bulkDeleteDraftPostsRequest = {};
var _bulkDeleteDraftPostsResponse = { results: '_bulkDraftPostResult' };
var _bulkDraftPostResult = { item: '_draftPost' };
var _bulkRejectDraftPostRequest = {};
var _bulkRejectDraftPostResponse = { results: '_bulkDraftPostResult' };
var _bulkRevertToUnpublishedRequest = {};
var _bulkRevertToUnpublishedResponse = { results: '_bulkDraftPostResult' };
var _bulkUpdateDraftPostLanguageRequest = {};
var _bulkUpdateDraftPostLanguageResponse = {
    results: '_bulkDraftPostResult',
};
var _bulkUpdateDraftPostsRequest = {
    scheduledPublishDate: 'google.protobuf.Timestamp',
    draftPosts: '_maskedDraftPosts',
};
var _bulkUpdateDraftPostsResponse = { results: '_bulkDraftPostResult' };
var _category = {
    updatedDate: 'google.protobuf.Timestamp',
    coverImage: '_image',
};
var _createDraftPostRequest = { draftPost: '_draftPost' };
var _createDraftPostResponse = { draftPost: '_draftPost' };
var _deleteDraftPostRequest = {};
var _deleteDraftPostResponse = {};
var _design = { poll: '_pollDesign' };
var _draftPost = {
    editedDate: 'google.protobuf.Timestamp',
    scheduledPublishDate: 'google.protobuf.Timestamp',
    firstPublishedDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    heroImage: '_image',
    richContent: '_richContent',
    moderationDetails: '_moderationDetails',
    media: '_blogMedia',
};
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getDeletedDraftPostRequest = {};
var _getDeletedDraftPostResponse = { draftPost: '_draftPost' };
var _getDraftPostRequest = {};
var _getDraftPostResponse = { draftPost: '_draftPost' };
var _getDraftPostTotalsRequest = {};
var _getDraftPostTotalsResponse = {};
var _getPostAmountsByLanguageRequest = {};
var _getPostAmountsByLanguageResponse = {};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _imageData = { image: '_media' };
var _isDraftPostAutoTranslatableRequest = {};
var _isDraftPostAutoTranslatableResponse = {};
var _item = { image: '_itemImage', video: '_itemVideo' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _itemVideo = { media: '_media', thumbnail: '_media' };
var _listDeletedDraftPostsRequest = {};
var _listDeletedDraftPostsResponse = { draftPosts: '_draftPost' };
var _listDraftPostsRequest = {};
var _listDraftPostsResponse = { draftPosts: '_draftPost' };
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _markPostAsInModerationRequest = {};
var _markPostAsInModerationResponse = { draftPost: '_draftPost' };
var _maskedDraftPosts = {
    fieldMask: 'google.protobuf.FieldMask',
    draftPost: '_draftPost',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _moderationDetails = {
    submittedDate: 'google.protobuf.Timestamp',
    moderationDate: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _publishDraftPostRequest = {};
var _publishDraftPostResponse = {};
var _queryDraftPostsRequest = {};
var _queryDraftPostsResponse = { draftPosts: '_draftPost' };
var _rejectDraftPostRequest = {};
var _rejectDraftPostResponse = { draftPost: '_draftPost' };
var _removeFromTrashBinRequest = {};
var _removeFromTrashBinResponse = {};
var _restoreFromTrashBinRequest = {};
var _restoreFromTrashBinResponse = { draftPost: '_draftPost' };
var _revertToUnpublishedRequest = {};
var _revertToUnpublishedResponse = { draftPost: '_draftPost' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _translateCategoryRequest = {};
var _translateCategoryResponse = { category: '_category' };
var _translateDraftRequest = {};
var _translateDraftResponse = { draftPost: '_draftPost' };
var _unpublishPostRequest = {};
var _unpublishPostResponse = {};
var _updateDraftPostContentRequest = { richContent: '_richContent' };
var _updateDraftPostContentResponse = { draftPost: '_draftPost' };
var _updateDraftPostLanguageRequest = {};
var _updateDraftPostLanguageResponse = { draftPost: '_draftPost' };
var _updateDraftPostRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    scheduledPublishDate: 'google.protobuf.Timestamp',
    draftPost: '_draftPost',
};
var _updateDraftPostResponse = { draftPost: '_draftPost' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
var _wixMedia = { image: '_image', videoV2: '_videoV2' };
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl(opts) {
    var domainToMappings = {
        _api_base_domain_: [
            {
                srcPath: '/draft-post-service-api-proxy',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts/create',
                destPath: '/v3/bulk/draft-posts/create',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts',
                destPath: '/v3/bulk/draft-posts',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts/create',
                destPath: '/v3/bulk/draft-posts/create',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts',
                destPath: '/v3/bulk/draft-posts',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
            {
                srcPath: '/_api/draft-post-service-api-proxy/v3/bulk/draft-posts',
                destPath: '/v3/bulk/draft-posts',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts/create',
                destPath: '/v3/bulk/draft-posts/create',
            },
            {
                srcPath: '/blog/v3/draft-posts/',
                destPath: '/v3/draft-posts',
            },
            {
                srcPath: '/blog/v3/bulk/draft-posts',
                destPath: '/v3/bulk/draft-posts',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api/v3/draft-posts',
                destPath: '/v3/draft-posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftStatsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/_api/v3/posts',
                destPath: '/v3/posts',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Gets draft post totals grouped by fields.
 * An example usage would be to group by status so one would know how many posts there are that are in PUBLISHED, UNPUBLISHED, DELETED, etc. statuses.
 */
export function getDraftPostTotals(payload) {
    var _a = serializer(_getDraftPostTotalsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDraftPostTotalsResponse, {}).fromJSON;
    function __getDraftPostTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftStatsService.GetDraftPostTotals',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftStatsServiceUrl({
                protoPath: '/v3/stats/draft-posts/totals',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftStatsServiceUrl({
                        protoPath: '/v3/stats/draft-posts/totals',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __getDraftPostTotals.fromReq = fromReq;
    __getDraftPostTotals.__isAmbassador = true;
    return __getDraftPostTotals;
}
/**
 * Creates a draft post.
 *
 * For 3rd-party apps, `memberId` is a required field.
 *
 * In `categoryIds`, only categories that already exist will be added to the draft post. Including
 * `categoryIds` that do not exist will not return an error, but they will not be added to the `categoryIds` array.
 * If some of the categories exist, those will be added while those that do not exist will not be added to `categoryIds`.
 * You can check which categories are available with
 * List Categories ([SDK](https://dev.wix.com/docs/sdk/backend-modules/blog/categories/list-categories) | [REST](https://dev.wix.com/docs/rest/business-solutions/blog/category/list-categories)).
 */
export function createDraftPost(payload) {
    var _a = serializer(_createDraftPostRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __createDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.CreateDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/draft-posts', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDraftPost.fromReq = fromReq;
    __createDraftPost.__isAmbassador = true;
    return __createDraftPost;
}
/** Creates multiple draft posts. */
export function bulkCreateDraftPosts(payload) {
    var _a = serializer(_bulkCreateDraftPostsRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkCreateDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.BulkCreateDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/bulk/draft-posts/create', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateDraftPosts.fromReq = fromReq;
    __bulkCreateDraftPosts.__isAmbassador = true;
    return __bulkCreateDraftPosts;
}
/** Updates multiple draft posts. */
export function bulkUpdateDraftPosts(payload) {
    var _a = serializer(_bulkUpdateDraftPostsRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _maskedDraftPosts: _maskedDraftPosts,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkUpdateDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.BulkUpdateDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/draft-posts/update', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateDraftPosts.fromReq = fromReq;
    __bulkUpdateDraftPosts.__isAmbassador = true;
    return __bulkUpdateDraftPosts;
}
/**
 * Retrieves a list of up to 100 deleted draft posts.
 *
 * List Draft Posts runs with these defaults, which you can override:
 * - `editedDate` is sorted in descending order. In this case,`editedDate` implies the date the post was deleted.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 */
export function listDeletedDraftPosts(payload) {
    var _a = serializer(_listDeletedDraftPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listDeletedDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.ListDeletedDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/draft-posts/trash-bin', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedDraftPosts.fromReq = fromReq;
    __listDeletedDraftPosts.__isAmbassador = true;
    return __listDeletedDraftPosts;
}
/** Retrieves a draft post by the provided ID. */
export function getDraftPost(payload) {
    var _a = serializer(_getDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.GetDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDraftPost.fromReq = fromReq;
    __getDraftPost.__isAmbassador = true;
    return __getDraftPost;
}
/** Updates content of a draft post. */
export function updateDraftPostContent(payload) {
    var _a = serializer(_updateDraftPostContentRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDraftPostContentResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __updateDraftPostContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.UpdateDraftPostContent',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPostId}/content',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDraftPostContent.fromReq = fromReq;
    __updateDraftPostContent.__isAmbassador = true;
    return __updateDraftPostContent;
}
/** Updates a draft post. */
export function updateDraftPost(payload) {
    var _a = serializer(_updateDraftPostRequest, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __updateDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'PATCH',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.UpdateDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPost.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDraftPost.fromReq = fromReq;
    __updateDraftPost.__isAmbassador = true;
    return __updateDraftPost;
}
/**
 * Moves a draft post to the trash bin.
 * A published post can also be deleted by the `post.id`. See the Posts API ([SDK](https://dev.wix.com/docs/sdk/backend-modules/blog/posts/) | [REST](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/post-object)) for more information about posts.
 *
 * To permanently delete a post bypassing the trash bin, set the `permanent` field value to `true`. The post can't be restored after this.
 */
export function deleteDraftPost(payload) {
    var _a = serializer(_deleteDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteDraftPostResponse, {}).fromJSON;
    function __deleteDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.DeleteDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteDraftPost.fromReq = fromReq;
    __deleteDraftPost.__isAmbassador = true;
    return __deleteDraftPost;
}
/**
 * Permanently deletes a draft post that is currently in the trash bin.
 *
 * This action is permanent and can't be reversed.
 */
export function removeFromTrashBin(payload) {
    var _a = serializer(_removeFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeFromTrashBinResponse, {}).fromJSON;
    function __removeFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.RemoveFromTrashBin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/trash-bin/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeFromTrashBin.fromReq = fromReq;
    __removeFromTrashBin.__isAmbassador = true;
    return __removeFromTrashBin;
}
/** Deletes multiple draft posts. */
export function bulkDeleteDraftPosts(payload) {
    var _a = serializer(_bulkDeleteDraftPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkDeleteDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'DELETE',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.BulkDeleteDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/bulk/draft-posts', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteDraftPosts.fromReq = fromReq;
    __bulkDeleteDraftPosts.__isAmbassador = true;
    return __bulkDeleteDraftPosts;
}
/**
 * Retrieves a list of up to 100 draft posts per request.
 *
 * List Draft Posts runs with these defaults, which you can override:
 * - `editedDate` is sorted in descending order.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 */
export function listDraftPosts(payload) {
    var _a = serializer(_listDraftPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.ListDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/draft-posts', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDraftPosts.fromReq = fromReq;
    __listDraftPosts.__isAmbassador = true;
    return __listDraftPosts;
}
/** Retrieves a deleted draft post from the trash bin by the provided ID. */
export function getDeletedDraftPost(payload) {
    var _a = serializer(_getDeletedDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getDeletedDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.GetDeletedDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/trash-bin/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedDraftPost.fromReq = fromReq;
    __getDeletedDraftPost.__isAmbassador = true;
    return __getDeletedDraftPost;
}
/** Restores a deleted draft post from the trash bin by the provided ID. */
export function restoreFromTrashBin(payload) {
    var _a = serializer(_restoreFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreFromTrashBinResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __restoreFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.RestoreFromTrashBin',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/trash-bin/{draftPostId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreFromTrashBin.fromReq = fromReq;
    __restoreFromTrashBin.__isAmbassador = true;
    return __restoreFromTrashBin;
}
/**
 * Retrieves a list of up to 100 draft posts, given the provided paging, filtering, and sorting.
 *
 * Query Draft Posts runs with these defaults, which you can override:
 * - `editedDate` is sorted in `DESC` order.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/docs/rest/business-solutions/blog/draft-posts/filter-and-sort).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryDraftPosts(payload) {
    var _a = serializer(_queryDraftPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryDraftPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __queryDraftPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.QueryDraftPosts',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({ protoPath: '/v3/draft-posts/query', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryDraftPosts.fromReq = fromReq;
    __queryDraftPosts.__isAmbassador = true;
    return __queryDraftPosts;
}
/**
 * Publishes a draft post by ID. This creates a new post ([SDK](https://dev.wix.com/docs/sdk/backend-modules/blog/posts/) | [REST](https://dev.wix.com/docs/rest/business-solutions/blog/posts-stats/post-object))
 * with the data from the draft post.
 *
 * If the draft post was already published, the published post will be updated with the latest values
 * from the draft post.
 */
export function publishDraftPost(payload) {
    var _a = serializer(_publishDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishDraftPostResponse, {}).fromJSON;
    function __publishDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.PublishDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPostId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishDraftPost.fromReq = fromReq;
    __publishDraftPost.__isAmbassador = true;
    return __publishDraftPost;
}
/** Reverts published post back to draft post making it invisible for the users. */
export function unpublishPost(payload) {
    var _a = serializer(_unpublishPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unpublishPostResponse, {}).fromJSON;
    function __unpublishPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DraftPostService.UnpublishPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DraftPostServiceUrl({
                protoPath: '/v3/draft-posts/{draftPostId}/unpublish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unpublishPost.fromReq = fromReq;
    __unpublishPost.__isAmbassador = true;
    return __unpublishPost;
}
/** Translates and returns translation of category for specified language. */
export function translateCategory(payload) {
    var _a = serializer(_translateCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_translateCategoryResponse, {
        _category: _category,
        _focalPoint: _focalPoint,
        _image: _image,
    }).fromJSON;
    function __translateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.TranslateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({
                protoPath: '/v3/multilingual/category/{categoryId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __translateCategory.fromReq = fromReq;
    __translateCategory.__isAmbassador = true;
    return __translateCategory;
}
/** Creates and returns translation of a draft in specified language. */
export function translateDraft(payload) {
    var _a = serializer(_translateDraftRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_translateDraftResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __translateDraft(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.TranslateDraft',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({
                protoPath: '/v3/multilingual/draft/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __translateDraft.fromReq = fromReq;
    __translateDraft.__isAmbassador = true;
    return __translateDraft;
}
/** Checks whether enough translation credits are available to auto translate a draft post. */
export function isDraftPostAutoTranslatable(payload) {
    var _a = serializer(_isDraftPostAutoTranslatableRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_isDraftPostAutoTranslatableResponse, {}).fromJSON;
    function __isDraftPostAutoTranslatable(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.IsDraftPostAutoTranslatable',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({
                protoPath: '/v3/multilingual/is-draft-post-auto-translatable/{draftPostId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __isDraftPostAutoTranslatable.fromReq = fromReq;
    __isDraftPostAutoTranslatable.__isAmbassador = true;
    return __isDraftPostAutoTranslatable;
}
/** Updates draft post language and replaces its categories to the ones existing in specified language. */
export function updateDraftPostLanguage(payload) {
    var _a = serializer(_updateDraftPostLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateDraftPostLanguageResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __updateDraftPostLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.UpdateDraftPostLanguage',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({
                protoPath: '/v3/multilingual/update-draft-post-language/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateDraftPostLanguage.fromReq = fromReq;
    __updateDraftPostLanguage.__isAmbassador = true;
    return __updateDraftPostLanguage;
}
/** Bulk updates draft post language and replaces its categories to the ones existing in specified language. */
export function bulkUpdateDraftPostLanguage(payload) {
    var _a = serializer(_bulkUpdateDraftPostLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateDraftPostLanguageResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkUpdateDraftPostLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.BulkUpdateDraftPostLanguage',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({
                protoPath: '/v3/bulk/multilingual/update-draft-post-language',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateDraftPostLanguage.fromReq = fromReq;
    __bulkUpdateDraftPostLanguage.__isAmbassador = true;
    return __bulkUpdateDraftPostLanguage;
}
/** Gets post amounts by each language in posts. */
export function getPostAmountsByLanguage(payload) {
    var _a = serializer(_getPostAmountsByLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostAmountsByLanguageResponse, {}).fromJSON;
    function __getPostAmountsByLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogMultilingualService.GetPostAmountsByLanguage',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogMultilingualServiceUrl({ protoPath: '/v3/multilingual/count/post', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostAmountsByLanguage.fromReq = fromReq;
    __getPostAmountsByLanguage.__isAmbassador = true;
    return __getPostAmountsByLanguage;
}
/** Reverts post status back from moderation to unpublished. */
export function bulkRevertToUnpublished(payload) {
    var _a = serializer(_bulkRevertToUnpublishedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRevertToUnpublishedResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkRevertToUnpublished(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.BulkRevertToUnpublished',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({
                protoPath: '/v3/bulk/moderation/revert-by-ids',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRevertToUnpublished.fromReq = fromReq;
    __bulkRevertToUnpublished.__isAmbassador = true;
    return __bulkRevertToUnpublished;
}
/** Rejects draft post into unpublished status. */
export function bulkRejectDraftPost(payload) {
    var _a = serializer(_bulkRejectDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkRejectDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _bulkDraftPostResult: _bulkDraftPostResult,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __bulkRejectDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.BulkRejectDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({
                protoPath: '/v3/bulk/moderation/reject-by-ids',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkRejectDraftPost.fromReq = fromReq;
    __bulkRejectDraftPost.__isAmbassador = true;
    return __bulkRejectDraftPost;
}
/** Reverts post status back from moderation to unpublished. */
export function revertToUnpublished(payload) {
    var _a = serializer(_revertToUnpublishedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_revertToUnpublishedResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __revertToUnpublished(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.RevertToUnpublished',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({
                protoPath: '/v3/moderation/revert/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __revertToUnpublished.fromReq = fromReq;
    __revertToUnpublished.__isAmbassador = true;
    return __revertToUnpublished;
}
/**
 * Deprecated on '2022-09-01'. Use DraftPostService.UpdateDraftPost.
 * Rejects draft post into unpublished status.
 */
export function rejectDraftPost(payload) {
    var _a = serializer(_rejectDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rejectDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __rejectDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.RejectDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({
                protoPath: '/v3/moderation/reject/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __rejectDraftPost.fromReq = fromReq;
    __rejectDraftPost.__isAmbassador = true;
    return __rejectDraftPost;
}
/**
 * Deprecated on '2022-09-01'. Use DraftPostService.UpdateDraftPost.
 * Approves draft post by either publishing it or scheduling it for publish.
 */
export function approveDraftPost(payload) {
    var _a = serializer(_approveDraftPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_approveDraftPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __approveDraftPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.ApproveDraftPost',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({
                protoPath: '/v3/moderation/approve/{postId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __approveDraftPost.fromReq = fromReq;
    __approveDraftPost.__isAmbassador = true;
    return __approveDraftPost;
}
/** Updates post statuses to mark post as being in moderation. */
export function markPostAsInModeration(payload) {
    var _a = serializer(_markPostAsInModerationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markPostAsInModerationResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _design: _design,
        _draftPost: _draftPost,
        _focalPoint: _focalPoint,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __markPostAsInModeration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.draft',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.BlogModerationService.MarkPostAsInModeration',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3BlogModerationServiceUrl({ protoPath: '/v3/moderation/{postId}', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markPostAsInModeration.fromReq = fromReq;
    __markPostAsInModeration.__isAmbassador = true;
    return __markPostAsInModeration;
}
//# sourceMappingURL=http.impl.js.map